module.exports = __webpack_public_path__ + "img/icdeposit.75e07d99.png";